import { Button } from "@/components/ui/button";
import { ArrowRight, GraduationCap, Home, Shield } from "lucide-react";
import familyLegacy from "@/assets/family-legacy.jpeg";

const LegacySection = () => {
  const funds = [
    { icon: GraduationCap, name: "The Lady Johnson Fund", purpose: "Education" },
    { icon: Home, name: "The Mabel's Key Fund", purpose: "Homeownership" },
    { icon: Shield, name: "The Augustus Fund", purpose: "Veterans" },
  ];

  return (
    <section className="py-20 md:py-32 bg-muted/50">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <span className="text-accent font-semibold uppercase tracking-widest text-sm">
              The Heart of the Mission
            </span>
            <h2 className="text-4xl md:text-5xl font-bold leading-tight">
              Success Without a Successor is{" "}
              <span className="text-plum">
                Failure.
              </span>
            </h2>
            <p className="text-xl text-accent font-medium">
              The Mabel & Augustus Institute for Family Freedom.
            </p>
            <p className="text-lg text-muted-foreground leading-relaxed">
              We don't build wealth just to accumulate; we build it to restore. A portion of every speaking fee and real estate transaction goes directly to The Mabel & Augustus Institute to fund the gap for others.
            </p>
            
            <div className="space-y-4 pt-4">
              {funds.map((fund, index) => (
                <div key={index} className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-full bg-accent/10 flex items-center justify-center flex-shrink-0">
                    <fund.icon className="w-6 h-6 text-accent" />
                  </div>
                  <div>
                    <span className="font-semibold text-foreground">{fund.name}</span>
                    <span className="text-muted-foreground ml-2">({fund.purpose})</span>
                  </div>
                </div>
              ))}
            </div>

            <a 
              href="https://webuildfamily.com" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              <Button size="lg" variant="premium" className="group mt-6">
                Visit The Foundation
                <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" />
              </Button>
            </a>
          </div>

          <div className="flex justify-center">
            <div className="relative w-full max-w-md">
              <div className="absolute -inset-4 bg-gradient-to-br from-accent/15 to-primary/10 rounded-3xl blur-xl" />
              <img 
                src={familyLegacy} 
                alt="The Bryant Family" 
                className="relative w-full rounded-3xl shadow-luxury object-cover aspect-[4/3]"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LegacySection;
